export default __webpack_public_path__ + "static/media/VealParmSub.17e8c33f.jpg";